module.exports = __webpack_public_path__ + "assets/images/2-3E5usgM.jpg";